import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

// Shown instead of the calendar preview when the coach has setup items still missing.
// Same look as the Platform Scheduling Unavailable popup used in the pairing flow.
const CalendarSetupIncompleteModal = ({
  show,
  onHide,
  coachName,
  missingFields,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    size='lg'
    className='payment-modal'
    dialogClassName='payment-modal-dialog justify-content-center'>
    <Modal.Header className='payment-modal-header d-flex justify-content-center'>
      <h3 className='payment-modal-title mb-0 text-uppercase'>
        Calendar Setup Incomplete
      </h3>
    </Modal.Header>
    <Modal.Body className='payment-modal-body'>
      <div className='sa4 font-15px mb-3'>
        The calendar preview is not available until this coach finishes their
        calendar setup.
      </div>
      <ul className='pl-3 mb-4 sa4 font-15px'>
        <li className='mb-2'>
          <span className='font-weight-bold'>Missing Fields</span>
          <span> — {missingFields.join(', ')}</span>
        </li>
      </ul>
    </Modal.Body>
    <Modal.Footer className='border-0 d-flex justify-content-end gap-3 flex-row'>
      <Button
        variant='saffron'
        className='px-4 text-uppercase'
        size='sm'
        onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)

CalendarSetupIncompleteModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  coachName: PropTypes.string,
  missingFields: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default CalendarSetupIncompleteModal
